import { render, staticRenderFns } from "./vcSelectArea.vue?vue&type=template&id=38780e4e&"
import script from "./vcSelectArea.vue?vue&type=script&lang=js&"
export * from "./vcSelectArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports